import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function resolveImageUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const CATEGORIES = [
  { id: "mindmaps", label: "Mindmaps" },
  { id: "education", label: "Education" },
  { id: "books", label: "Books" },
  { id: "new_releases", label: "New Releases" },
];

export const CATEGORY_LABEL = {
  mindmaps: "Mindmaps",
  education: "Education",
  books: "Books",
  new_releases: "New Releases",
};

export const CATEGORY_STYLE = {
  mindmaps: "bg-cat-mindmaps text-cat-mindmaps-text",
  education: "bg-cat-education text-cat-education-text",
  books: "bg-cat-books text-cat-books-text",
  new_releases: "bg-cat-new-releases text-cat-new-releases-text",
};

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
}
